// extracted by mini-css-extract-plugin
module.exports = {"field":"style_field__gkt1d","fields":"style_fields__2_wjr"};